import { render, staticRenderFns } from "./IntegrationsConfig.vue?vue&type=template&id=8bfbaf5e&"
import script from "./IntegrationsConfig.vue?vue&type=script&lang=js&"
export * from "./IntegrationsConfig.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsConfig.vue?vue&type=style&index=0&id=8bfbaf5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports